<template>
    <div>
        <div>
            <a-input @click="showSelecter" :readOnly="true" :value="selectname ? selectname : '选择目录'" style="width:150px;cursor:pointer;" placeholder="选择目录">
                <a-icon slot="prefix" type="folder-open"  theme="filled" style="color:#ffe792;font-size:18px;" />

                <a-icon title="取消选择" slot="suffix" v-if="selectname"  @click="handleCancleSelect" type="close-circle" class="btnIcon" />
                <a-icon title="点击选择" slot="suffix" v-else type="select" @click="showSelecter" class="btnIcon" />
            </a-input>
        </div>
        <a-modal :title="title" :visible="isShow" :confirm-loading="confirmLoading" width="450px" @cancel="handleCancel">
            <div v-show="editorShow" class="editorBox">
                <a-spin :spinning="formLoading">
                    <div class="ptitle">{{formInline.desc}}</div>
                    <a-form-model layout="inline" :model="formInline" @submit="handleSubmit" @submit.native.prevent >
                        <a-form-model-item  label="目录编码">
                            <a-input v-model="catalogcode_after" :readOnly="formInline.id != undefined" :maxLength="200" placeholder="目录编码"  style="width:220px;">
                                <template  slot="prefix">
                                    <a-icon type="code" theme="filled" style="color:#ffe792" />
                                    <span class="catalogcodePrex">{{catalogcode_pre}}</span>
                                </template>
                            </a-input>
                        </a-form-model-item>
                        <a-form-model-item  label="目录名">
                            <a-input v-model="formInline.catalogname" :maxLength="200"  placeholder="目录名" style="margin-left:13px;width:220px;">
                                <a-icon slot="prefix" type="folder-add" theme="filled" style="color:#ffe792" />
                            </a-input>
                        </a-form-model-item>
                        <a-form-model-item  label="排序号">
                            <a-input-number v-model="formInline.ordernum"  :min="1" :max="999"  placeholder="排序号"  style="margin-left:13px;width:220px;">
                                <a-icon slot="prefix" type="ordered-list"  style="color:#ffe792" />
                            </a-input-number>
                        </a-form-model-item>
                        <a-form-model-item>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :disabled="formInline.catalogcode === '' || formInline.catalogname === ''"
                        >
                            保存
                        </a-button>
                        <a-button @click="handleCancelForm" class="ml10">取消</a-button>
                        </a-form-model-item>
                    </a-form-model>
                </a-spin>
            </div>
                
            <a-spin :spinning="treeLoading">
                <a-tree 
                    :tree-data="treeData" 
                    :show-line="showLine" 
                    :show-icon="showIcon"
                    :expandedKeys="expandedKeys" 
                    :selectedKeys="selectedKeys"
                    @expand="handleExpand"
                >

                    <template slot="custom" slot-scope="item">
                        <span @click="onSelect(item)" :class="{ 'treeselected' : (item.key == selectkey) }" :id="item.menucode">{{ item.title }}</span>
                        <div class="op_box">
                            <a-icon type="plus" @click="()=> append(item)" title="新建下级"/>
                            <a-icon type="edit" @click="()=> edit(item)" title="编辑" v-if="item.pcatalogcode != -1" />
                            <a-popconfirm @confirm="() => remove(item)" v-if="item.pcatalogcode != -1">
                                <template slot="title">
                                    <p>{{ '确认将【' + item.catalogname + '】删除？' }}</p>
                                </template>
                                <a-icon type="delete" title="删除" />
                            </a-popconfirm>
                        </div>

                    </template>
                </a-tree>
            </a-spin>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk" v-if="formInline.catalogcode == ''">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>

export default {
    data() {
        return {
            title:'选择目录',
            confirmLoading: false,
            formLoading:false,
            isShow:false,
            treeLoading:false,
            showLine: true,
            showIcon: false,
            expandedKeys: [],
            selectedKeys:[],
            treeData: [],
            deleteMenucodes:[],
            labelCol: { span: 4 },
            wrapperCol: { span: 12 },
            editorShow:false,
            formInline: {
                platformcode:'',
                catalogcode:'',
                catalogname:'',
                pcatalogcode:'',
                ordernum:'',
                save_type:'',
                desc:''
            },
            selectkey:'',
            selectname:'',
            catalogcode_pre:0,
            catalogcode_after:'',
        }
    },

    props:{
        platformcode:String,
        mmkey:String
    },
    methods: {

        //设置选中值
        init(key){
            if(!key){
                this.selectkey = '';
                this.selectname = '';
                return;
            }
            this.selectkey = key;
            this.getAllMenu()
        },
        //如果有需要初始化的key值，寻找keyname
        getKeyName(){
            console.log('key 值 ' + this.selectkey)

        },
        //显示选择框
        showSelecter(){
            this.handleCancelForm();
            this.getAllMenu();
            this.isShow = true;
        },
        //关闭
        handleCancel(){
            this.isShow = false;
        },
        //确认选择
        handleOk(){
            this.$emit('catalogcodechange',this.selectkey)
            this.isShow = false;
        },
        //扩展
        handleExpand(expandedKeys){
            this.expandedKeys = expandedKeys
        },
        //树选择
        onSelect(item) {
            if(!item.key){
                return
            }
            this.selectkey = item.key;
            this.selectname = item.title;
        },
        handleCancleSelect(){
            this.selectkey = '',
            this.selectname = ''
            this.$emit('catalogcodechange',this.selectkey)
        },
        //新增编辑取消
        handleCancelForm(){
            this.editorShow = false;
            this.catalogcode_pre = 0;
            this.catalogcode_after = '';
            this.formInline = {
                platformcode:'',
                catalogcode:'',
                catalogname:'',
                pcatalogcode:'',
                ordernum:'',
                save_type:'',
                desc:''
            }
        },
        //新增或者保存目录
        handleSubmit(){
            let data_ = this.formInline;
            let pre_ = this.catalogcode_pre;
            let after_ = this.catalogcode_after ;
            let queryType = data_.save_type == 'new' ? 'cloudconfig/addcatalog' : 'cloudconfig/updatecatalog'
            //编辑
            if(!pre_ || ! after_){
                this.message.error('请填写目录名')
                return
            }
            data_.catalogcode = pre_ + after_;
            let that = this;
            that.formLoading = true;
            that.$store.dispatch({
                type: queryType,
                params: {
                    ...data_,
                    
                    urlparams: false,
                },
                showMsg: false
            },).then((res) => {
                that.formLoading = false;
                if(res.data.success == 1){
                    that.handleCancelForm();
                    that.getAllMenu();
                }
            });
        },
        handleCode(){
            let resultcode = this.formInline.catalogcode;
            if(resultcode.length > 0){
                this.catalogcode_pre = resultcode[0];
                this.catalogcode_after = resultcode.slice(1);
            }
            else{
                this.catalogcode_pre = '';
                this.catalogcode_after = '';
            }
        },
        //新建下级
        append(item) {
            let maxCode = 0;
            item.bcodes.forEach(element => {
                if(parseInt(element) > maxCode){
                    maxCode = parseInt(element)
                }
            });
            maxCode++;
            //格式code  两位数 不能超过 99 
            if(maxCode > 99){
                this.message.error('子节点数不能超过100')
                return
            }
            else if(maxCode < 10){
                maxCode = '0' + maxCode
            }
            let resultcode = item.catalogcode + maxCode;
            this.formInline = {
                platformcode:item.platformcode,
                catalogcode:resultcode,//根据规则生成 父级 code  + 当前最大编号
                catalogname:'',
                pcatalogcode:item.catalogcode,
                ordernum:'',
                save_type:'new',
                createuser:this.G.getCurrentUser().username,
                id:undefined,
                desc:'新建【'+ item.catalogname +'】下级'
            }
            this.handleCode();
            this.editorShow = true;
        },
        //编辑
        edit(item) {
            this.formInline = {
                platformcode:item.platformcode,
                catalogcode:item.catalogcode,//根据规则生成 父级 code  + 当前最大编号
                catalogname:item.catalogname,
                pcatalogcode:item.pcatalogcode,
                ordernum:item.ordernum,
                updateuser:this.G.getCurrentUser().username,
                save_type:'edit',
                id:item.id,
                desc:'编辑【'+ item.catalogname +'】'
            }
            this.handleCode();
            this.editorShow = true;
        },
        //删除
        remove(item) {
            this.$store.dispatch({
                type: "cloudconfig/delcatalog",
                params: {
                    id: item.id,
                    platformcode:item.platformcode,
                    urlparams:false,
                }
            }).then((res) => {
                if (res.status == '200') {
                    this.getAllMenu();
                }
            });
        },
        //递归树结构
        handleTreeData(treeItem) {
            treeItem.title = treeItem.catalogname;
            treeItem.key = treeItem.catalogcode;
            if(this.selectkey == treeItem.key){
                this.selectname = treeItem.title
            }
            this.expandedKeys.push(treeItem.key)
            treeItem.children = [];
            treeItem.scopedSlots = {title: 'custom'};
            if(!treeItem.child){
                treeItem.child = [];
            }
            //排序
            treeItem.child.sort(function (a, b) {
                return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
            });
            //兄弟节点数组
            let brotherCodes = [];
            treeItem.child.forEach(element => {
                brotherCodes.push(element.catalogcode.slice(element.pcatalogcode.length))
            });
            treeItem.bcodes = brotherCodes;
            //递归子节点
            for (let index = 0; index < treeItem.child.length; index++) {
                const r_child = treeItem.child[index];
                treeItem.children.push(this.handleTreeData(r_child))
            }
            return treeItem;
        },
        //获取树
        getAllMenu() {
            let that = this;
            that.treeLoading = true;
            that.$store.dispatch({
                type: "cloudconfig/querycatalogs",
                params: {
                    catalogcode:0,
                    platformcode:that.platformcode,
                    urlparams: false,
                },
                showMsg: false
            },).then((res) => {
                that.treeLoading = false;

                let origin_data = res.data.data
                that.expandedKeys = [];
                if(origin_data.child){
                    //排序
                    origin_data.child.sort(function (a, b) {
                        return parseInt(a.ordernum) > parseInt(b.ordernum) ? 1 : -1
                    });
                }
                origin_data  = that.handleTreeData(origin_data);
                let result = [];
                result.push(origin_data)
                that.treeData = result;
            });
        },

    },
    mounted() {
    },
    components:{
    },
    watch:{
        'mmkey'(newVal){
            if(newVal){
                this.init(newVal);
            }
        }
    }
};
</script>

<style scoped>
    .btnIcon{
        color:#1890ff;
        font-size:18px;
    }
</style>

<style>

    .op_box{
        position:absolute;
        right: 6px;
        top: 7px;
    }

    .op_box i{
        padding:0 4px;
    }

    .editorBox{
        border: 1px solid lightgray;
        padding: 10px 18px;
        border-radius: 4px;
        margin-bottom: 20px;
    }

    .ptitle{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .treeselected{
        /* color: black; */
        background-color: #bae7ff;
    }

    .catalogcodePrex{
        padding: 0 4px;
        line-height: 0 !important;
    }
</style>
